"use strict";

jQuery(document).ready(function ($) {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",

      /*
       * Initialize
       */
      init: function (e) {
        $this = adpPopup;
        $this.popupInit(e);
        $this.events(e);
      },

      /* Events */
      events: function () {
        $(document).off(".adpPopup");

        $(document).on("click.adpPopup", ".popup-close", $this.closePopup);

        // ✅ only one accept handler; acceptPopup will close itself
        $(document).on("click.adpPopup", ".popup-accept", $this.acceptPopup);

        $(document).on(
          "click.adpPopup",
          ".age-verification__popup-close",
          $this.agePopup
        );
        $(document).on(
          "click.adpPopup",
          ".age-verification__popup-close",
          $this.closePopup
        );
        $(document).on(
          "click.adpPopup",
          ".age-verification__button-no",
          $this.ageDeclined
        );

        $(document).on("keyup.adpPopup", function (e) {
          if (e.key === "Escape")
            $('.popup-open[data-esc-close="true"]').each((_, p) =>
              $this.closePopup(p)
            );
          if (e.key === "F4")
            $('.popup-open[data-f4-close="true"]').each((_, p) =>
              $this.closePopup(p)
            );
        });

        $(document).on("click.adpPopup", ".popup-overlay", function () {
          $('.popup-open[data-overlay-close="true"]').each((_, p) =>
            $this.closePopup(p)
          );
        });
      },

      /*
       * Init popup elements
       */
      popupInit: function () {
        // Set scroll direction (namespace + avoid duplicates)
        $(document)
          .off("scroll.adpPopupDirection")
          .on("scroll.adpPopupDirection", function () {
            var scrollCurrent = window.scrollY;
            $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
            $this.sPrevious = scrollCurrent;
          });

        // Open popup
        $(".popup").each(function (index, popup) {
          // Manual Launch.
          if ("manual" === $(popup).data("open-trigger")) {
            var selector = $(popup).data("open-manual-selector");

            if (selector) {
              $(selector).addClass("popup-trigger");

              // prevent multi-binding per init
              $(document)
                .off("click.adpPopupManual", selector)
                .on("click.adpPopupManual", selector, function (e) {
                  e.preventDefault();

                  $(popup).removeClass("popup-already-opened");
                  $this.openPopup(popup);

                  if (e.currentTarget.classList.contains("popup")) {
                    $this.closePopup(selector);
                  }
                });
            }
          }

          // Checks whether a popup should be displayed or not.
          if (
            !$this.isAllowPopup(popup) &&
            !$(popup).hasClass("age-verification")
          ) {
            return;
          }

          $this.openTriggerPopup(popup);
        });
      },

      /*
       * Trigger open popup
       */
      openTriggerPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;

        // ✅ If this popup uses "accept" button action and was accepted before -> never open again
        if ($(popup).data("has-accept") === true) {
          var id = $(popup).data("id");
          var accepted = $this.getStorage("popup-accept-" + id);
          if (accepted) return;
        }

        var trigger = $(popup).data("open-trigger");

        // Age Verification.
        if ("none" === trigger) {
          var ageVerification = $this.getStorage(
            "popup-age-" + ($(popup).data("id") || 0)
          );
          if (!ageVerification) $this.openPopup(popup);
        }

        // Time Delay.
        if ("delay" === trigger) {
          var delaySeconds = parseInt(
            $(popup).data("open-delay-number") || 0,
            10
          );
          setTimeout(function () {
            $this.openPopup(popup);
          }, delaySeconds * 1000);

          setTimeout(function () {
            if (
              $(popup).hasClass("popup-main-image--left") ||
              $(popup).hasClass("popup-main-image--right")
            ) {
              if ($(popup).find(".popup-thumbnail").length) {
                if (window.innerWidth > 749) {
                  $(popup)
                    .find(".popup-thumbnail")
                    .css("width", $(popup).height());
                } else {
                  $(popup).find(".popup-thumbnail").css("width", "100%");
                }
              }
            }

            if (
              $(popup).hasClass("notification-banner-image--left") ||
              $(popup).hasClass("notification-banner-image--right")
            ) {
              if ($(popup).find(".notification-banner__image").length) {
                if (window.innerWidth > 749) {
                  $(popup)
                    .find(".notification-banner__image")
                    .css("width", $(popup).height());
                } else {
                  $(popup)
                    .find(".notification-banner__image")
                    .css("width", "100%");
                }
              }
            }
          }, 1000);

          window.addEventListener("resize", function () {
            setTimeout(function () {
              if (
                $(popup).hasClass("popup-main-image--left") ||
                $(popup).hasClass("popup-main-image--right")
              ) {
                if ($(popup).find(".popup-thumbnail").length) {
                  if (window.innerWidth > 749) {
                    $(popup)
                      .find(".popup-thumbnail")
                      .css("width", $(popup).height());
                  } else {
                    $(popup).find(".popup-thumbnail").css("width", "100%");
                  }
                }
              }

              if (
                $(popup).hasClass("notification-banner-image--left") ||
                $(popup).hasClass("notification-banner-image--right")
              ) {
                if ($(popup).find(".notification-banner__image").length) {
                  if (window.innerWidth > 749) {
                    $(popup)
                      .find(".notification-banner__image")
                      .css("width", $(popup).height());
                  } else {
                    $(popup)
                      .find(".notification-banner__image")
                      .css("width", "100%");
                  }
                }
              }
            }, 1000);
          });
        }

        // Exit Intent.
        if ("exit" === trigger) {
          // don't rebind multiple times for same popup
          if ($(popup).data("exit-bound")) return;
          $(popup).data("exit-bound", true);

          var showExit = true;
          document.addEventListener("mousemove", function (ev) {
            // Get current scroll position
            var scroll =
              window.pageYOffset || document.documentElement.scrollTop;
            if (ev.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }

        // Scroll Position.
        if ("scroll" === trigger) {
          // don't rebind multiple times for same popup
          if ($(popup).data("scroll-open-bound")) return;
          $(popup).data("scroll-open-bound", true);

          var pointScrollType = $(popup).data("open-scroll-type");
          var pointScrollPosition = parseFloat(
            $(popup).data("open-scroll-position") || 0
          );

          $(document).on(
            "scroll.adpPopupOpenScroll-" + $(popup).data("id"),
            function () {
              // Type px.
              if ("px" === pointScrollType) {
                if (window.scrollY >= pointScrollPosition) {
                  $this.openPopup(popup);
                }
              }

              // Type %.
              if ("%" === pointScrollType) {
                if ($this.getScrollPercent() >= pointScrollPosition) {
                  $this.openPopup(popup);
                }
              }
            }
          );
        }

        // Accept Agreement.
        if ("accept" === trigger) {
          var accept = $this.getStorage(
            "popup-accept-" + ($(popup).data("id") || 0)
          );

          if (!accept) {
            $this.openPopup(popup);
          }
        }
      },

      /*
       * Trigger close popup
       */
      closeTriggerPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;
        var trigger = $(popup).data("close-trigger");

        // Time Delay.
        if ("delay" === trigger) {
          var closeDelaySeconds = parseInt(
            $(popup).data("close-delay-number") || 0,
            10
          );
          setTimeout(function () {
            $this.closePopup(popup);
          }, closeDelaySeconds * 1000);
        }

        // Scroll Position.
        if ("scroll" === trigger) {
          // bind once per popup open
          if ($(popup).data("scroll-close-bound")) return;
          $(popup).data("scroll-close-bound", true);

          var pointScrollType = $(popup).data("close-scroll-type");
          var pointScrollPosition = parseFloat(
            $(popup).data("close-scroll-position") || 0
          );
          var initScrollPx = parseFloat($(popup).data("init-scroll-px") || 0);
          var initScrollPercent = parseFloat(
            $(popup).data("init-scroll-percent") || 0
          );

          $(document).on(
            "scroll.adpPopupCloseScroll-" + $(popup).data("id"),
            function () {
              if ("px" === pointScrollType) {
                if (
                  "up" === $this.sDirection &&
                  window.scrollY < initScrollPx - pointScrollPosition
                ) {
                  $this.closePopup(popup);
                }

                if (
                  "down" === $this.sDirection &&
                  window.scrollY >= initScrollPx + pointScrollPosition
                ) {
                  $this.closePopup(popup);
                }
              }

              if ("%" === pointScrollType) {
                var p = $this.getScrollPercent();

                if (
                  "up" === $this.sDirection &&
                  p < initScrollPercent - pointScrollPosition
                ) {
                  $this.closePopup(popup);
                }

                if (
                  "down" === $this.sDirection &&
                  p >= initScrollPercent + pointScrollPosition
                ) {
                  $this.closePopup(popup);
                }
              }
            }
          );
        }
      },

      /*
       * Open popup
       */
      openPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;

        // already open or blocked -> do NOT count, do NOT reopen
        if ($(popup).hasClass("popup-open")) return;
        if ($(popup).hasClass("popup-already-opened")) return;

        // check limit again as a safety net
        if (
          !$this.isAllowPopup(popup) &&
          !$(popup).hasClass("age-verification")
        ) {
          return;
        }

        // keeping focus on popup for accessibility
        $("main").attr("inert", "");
        $(".shopify-section-group-footer-group").attr("inert", "");
        $(".shopify-section-group-header-group").attr("inert", "");
        $(".skip-to-content-link").attr("inert", "");

        function setupBodyScroll() {
          // Adjust body scroll for popup with body scroll disabled
          if ($(popup).is('[data-body-scroll-disable="true"]')) {
            if (window.innerWidth > 749) {
              $("body").addClass("popup-scroll-hidden");
            } else if ($(popup).is('[data-mobile-disable="true"]')) {
              $("body").removeClass("popup-scroll-hidden");
            }
          }
        }

        // Hide body scroll.
        if ($(popup).is('[data-body-scroll-disable="true"]')) {
          setupBodyScroll();

          window.addEventListener("resize", function () {
            setTimeout(() => setupBodyScroll(), 500);
          });
        }

        // Display popup.
        $(popup).addClass("popup-open");

        // Set current scroll.
        $(popup).data("init-scroll-px", window.scrollY);
        $(popup).data("init-scroll-percent", $this.getScrollPercent());

        // ✅ Count ONLY on real open
        var popupId = $(popup).data("id");
        var storageKey = "popup-" + popupId;

        var current = parseInt($this.getStorage(storageKey) || 0, 10);
        var maxLimit = parseInt($(popup).data("limit-display") || 0, 10);

        var nextValue = current + 1;

        // Clamp to max limit
        if (maxLimit && nextValue > maxLimit) {
          nextValue = maxLimit;
        }

        $this.setStorage(storageKey, nextValue, {
          expires: $(popup).data("limit-lifetime"),
        });

        // Open animation.
        var animation = $(popup).data("open-animation");
        $this.applyAnimation(popup, animation);

        // Init close trigger.
        $this.closeTriggerPopup(popup);
      },

      /*
       * Age popup
       */
      agePopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");

        $this.setStorage("popup-age-" + $(popup).data("id"), 1, {
          expires: 360,
        });
      },

      /*
       * Age declined
       */
      ageDeclined: function () {
        $(".age-verification__question").removeClass("show");
        $(".age-verification__declined").addClass("show");
      },

      /*
       * Accept popup
       */
      acceptPopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");

        $this.setStorage("popup-accept-" + $(popup).data("id"), 1, {
          expires: 360,
        });

        // ✅ close immediately after accept
        $this.closePopup($el);
      },

      /*
       * Close popup
       */
      closePopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");

        var animation = $(popup).data("exit-animation");

        $this.applyAnimation(popup, animation, function () {
          $(popup).addClass("popup-already-opened");
          $(popup).removeClass("popup-open");
          $("body").removeClass("popup-scroll-hidden");
        });

        // make outside elements focusable again
        $("main").removeAttr("inert", "");
        $(".shopify-section-group-footer-group").removeAttr("inert", "");
        $(".shopify-section-group-header-group").removeAttr("inert", "");
        $(".skip-to-content-link").removeAttr("inert", "");
      },

      /*
       * Checks whether a popup should be displayed or not
       */
      isAllowPopup: function (popup) {
        var popupId = popup.getAttribute("data-id");
        var maxLimit = parseInt(
          popup.getAttribute("data-limit-display") || 0,
          10
        );

        if (!maxLimit || (window.Shopify && Shopify.designMode)) return true;

        var stored = parseInt($this.getStorage("popup-" + popupId) || 0, 10);
        return stored < maxLimit;
      },

      /*
       * Apply animation
       */
      applyAnimation: function (el, name, callback) {
        var popup = $(el).closest(".popup");
        var overlayName =
          typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

        // Overlay Animation.
        $(popup)
          .next(".popup-overlay")
          .addClass("popup-animated " + overlayName)
          .one(
            "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
            function () {
              $(this).removeClass("popup-animated " + overlayName);
            }
          );

        // Wrap Animation.
        $(popup)
          .find(".popup-wrap")
          .addClass("popup-animated " + name)
          .one(
            "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
            function () {
              $(this).removeClass("popup-animated " + name);
              if (typeof callback === "function") callback();
            }
          );
      },

      /*
       * Get local storage (with expiry)
       */
      getStorage: function (key) {
        var item = localStorage.getItem(key);
        if (!item) return undefined;

        try {
          var parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch (err) {
          return undefined;
        }
      },

      /*
       * Set local storage (with expiry)
       */
      setStorage: function (key, value, options) {
        options = options || {};

        var data = {
          value: value,
          expires: null,
        };

        if (options.expires) {
          var expiresDate = new Date();
          expiresDate.setDate(
            expiresDate.getDate() + parseInt(options.expires, 10)
          );
          data.expires = expiresDate.getTime();
        }

        localStorage.setItem(key, JSON.stringify(data));
      },

      /*
       * Get scroll percent
       */
      getScrollPercent: function () {
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";

        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();

  // Initialize.
  adpPopup.init();

  document.addEventListener("DOMContentLoaded", function () {
    // Support multiple popup form IDs (legacy and newsletter popup)
    var forms = Array.from(
      document.querySelectorAll("#form_contact_popup, #popup-newsletter-form")
    );
    forms.forEach(function (form) {
      if (!form) return;
      // preserve existing submit behaviour
      form.addEventListener("submit", function () {
        window.location.hash = "";
      });

      // Submit form on Enter when focused inside (exclude TEXTAREA)
      form.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          const target = e.target || e.srcElement;
          if (
            target &&
            target.tagName &&
            target.tagName.toLowerCase() === "textarea"
          )
            return;
          // prevent default to avoid unexpected behavior and trigger native submit
          e.preventDefault();
          // try to find a submit button first
          const submitBtn = form.querySelector(
            'button[type="submit"], input[type="submit"]'
          );
          if (submitBtn) {
            submitBtn.click();
          } else {
            form.submit();
          }
        }
      });
    });
  });

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });

  document.addEventListener("shopify:section:unload", function () {
    $("body").removeClass("popup-scroll-hidden");
  });
});
